import {observe} from '@github-ui/selector-observer'

// Close the Copilot AIC (AI credits) usage popover when focus leaves it.
observe('.js-copilot-aic-popover', popover => {
  popover.addEventListener('focusout', event => {
    // relatedTarget is the element receiving focus next. focusout also fires when
    // focus moves between controls in this popover, so keep it open in that case.
    const nextFocusedElement = (event as FocusEvent).relatedTarget
    if (nextFocusedElement instanceof Element && popover.contains(nextFocusedElement)) return

    popover.removeAttribute('open')
  })
})
